/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuTypeaheadContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuMultiSelectSearch_viewer$ref: FragmentReference;
export type SbSharedRefineMenuMultiSelectSearch_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuTypeaheadContainer_viewer$ref,
  +$refType: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a7cbf25c6bfae95a04b020f702c4c3aa';
module.exports = node;
